export default class MessageContentFilter {
    static $inject = ['$sce', '$translate'];

    constructor($sce, $translate) {
        this._$translate = $translate;
        this.$sce = $sce;
    }

    static factory($sce) {
        'ngInject';
        const f = new MessageContentFilter($sce);
        return f.filter.bind(f);
    }

    filter(message = {}) {
        const majorType = (message.mediaType || message.type || '').split('/')[0];

        if (message.value) {
            message.content = message.value;
        }

        if (this[majorType]) {
            return this[majorType](message);
        }
        else {
            return this.code(message);
        }
    }

    text(message) {
        return `<span>${message.content}</span>`;
    }

    code(message) {
        return `<pre class="u-wrap u-no-margin">${JSON.stringify(message.content)}</pre>`;
    }

    application(message) {
        try {
            switch (message.mediaType || message.type) {
                case 'application':
                case 'application/vnd.lime.media-link+json':
                    return this.mediaLink(message);
                case 'application/vnd.lime.location+json':
                    return this.location(message);
                case 'application/vnd.lime.select+json':
                    return this.select(message);
                case 'application/vnd.lime.sensitive+json':
                    return this.sensitive();
                case 'application/vnd.omni.attendance+json':
                    return this.attendance(message);
                default:
                    return this.code(message);
            }
        } catch(e) {
            return this.code(message);
        }
    }

    mediaLink(message) {
        const c = message.content;

        if (c.text) {
            return `<span>${c.text}</span>`;
        }

        return '';
    }

    select(message) {
        const body = message.content.text;
        let options = '';
        message.content.options.forEach((o) => {
            let option = o;
            if (typeof o === 'string') {
                option = JSON.parse(o);
            }
            options += `<li>${(option.order || '') + option.text}</li>`;
        });
        return `<span>${body}<ul>${options}</ul></span>`;
    }

    attendance(message) {
        return this.filter(message.content.content);
    }

    location(message) {
        const c = message.content;

        if (c.text) {
            return `<span>${c.text}</span>`;
        }

        return '';
    }

    sensitive() {
        this._$translate('modules.message.confidentialMessage').then((confidentialMessage) => `<span><em>${confidentialMessage}</em></span>`);
    }
}

// Explicit DI annotation for factory used by angular.filter registration
MessageContentFilter.factory.$inject = ['$sce'];
